import React, {useState} from 'react';
import {Modal, Button} from 'semantic-ui-react';
import './confirmation.scss';


const ConfirmationModal = ({
  order,
  onInvoiceClick,
  disabled,
}) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const onOpenModal = () => {
    setModalIsOpen(true);
  };

  const onInvoiceModalClick = () => {
    onInvoiceClick();
    setModalIsOpen(false);
  };

  return (
    <Modal
      size="tiny"
      className="quality-control-invoicing-confirmation"
      open={modalIsOpen}
      trigger={
        <Button type="button" primary disabled={disabled} onClick={onOpenModal}>
          Facturar
        </Button>
      }
    >
      <Modal.Header>Facturación orden</Modal.Header>

      <Modal.Content>
        <Modal.Description>
          <h3>{`¿Está seguro que desea facturar la orden ${order}?`}</h3>
        </Modal.Description>
      </Modal.Content>

      <Modal.Actions>
        <Button onClick={() => setModalIsOpen(false)}>Cancelar</Button>
        <Button positive onClick={() => onInvoiceModalClick()}>
          Facturar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmationModal;
